import { Link, useLocation } from 'react-router-dom';
import { TEAM_B_STEPS, teamBStepIndex } from '@/constants/steps';

/**
 * 顶部流程指示器(同 A 队 StepIndicator)
 * - 4 步:添加 / 记录 / 诊断 / 日记
 * - 首页不显示(已有作品流程卡片)
 */
export function StepIndicator() {
  const { pathname } = useLocation();
  if (pathname === '/') return null;

  const currentIdx = teamBStepIndex(pathname);

  return (
    <nav
      className="mb-3 flex items-center justify-between rounded-lg border border-slate-200 bg-white px-2 py-1.5 shadow-sm"
      aria-label="作品流程进度"
    >
      {TEAM_B_STEPS.map((s, i) => {
        const Icon = s.icon;
        const isCurrent = i === currentIdx;
        const isDone = currentIdx > i && currentIdx >= 0;
        return (
          <Link
            key={s.id}
            to={s.path}
            className={`flex flex-1 flex-col items-center gap-0.5 rounded-md px-1 py-1 text-[10px] transition ${
              isCurrent
                ? 'bg-teamB-primary/10 text-teamB-primary'
                : isDone
                  ? 'text-teamB-primary/70 hover:bg-teamB-primary/5'
                  : 'text-slate-400 hover:text-slate-600'
            }`}
            title={`${s.name} · 责任:${s.owner}`}
          >
            <div className="flex items-center gap-1">
              <span
                className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-semibold ${
                  isCurrent
                    ? 'bg-teamB-primary text-white'
                    : isDone
                      ? 'bg-teamB-primary/70 text-white'
                      : 'bg-slate-200 text-slate-500'
                }`}
              >
                {i + 1}
              </span>
              <Icon className="h-3.5 w-3.5" />
            </div>
            <span className="font-medium">{s.shortName}</span>
          </Link>
        );
      })}
    </nav>
  );
}
